import React from 'react';
import Select from 'react-select';
import IndefiniteProgressbar from "../IndefiniteProgressbar.mjs";

class SelectAA extends React.Component {
	constructor(opts) {
		super(opts);
		this.state = { aas: false, ente: opts.ente };
		this.loadAA.bind(this);
		this.aa2options.bind(this);
		this.onchange.bind(this);
		this.uid = "SelectAA-"+window.glob.generateUid();
	};
	componentDidMount() {
		if ( this.props.globPrefix && this.props.deps && this.props.deps.slot) {
			window.glob.register(this.props.globPrefix+'changed.'+this.props.deps.slot,(s)=> {
				if ( s ) {
					const p = window.glob.getStatus('prenotazione.values');
					this.setState({ ente: p.ente, aas: false });
				} else {
					this.setState({ ente: false, aas: false });
				}
			}, this.uid );
		}
	};
	componentWillUnmount() {
		if ( this.props.globPrefix && this.props.deps && this.props.deps.ente) {
			window.glob.unregister(this.props.globPrefix+'changed.'+this.props.deps.ente,this.uid );
		}
	};
	loadAA() {
		window.glob.api(
			'lsAAs',
			{ lente: this.state.ente.lente }
		).then( (e)=>{
			this.aa2options(e);
		})
	};
	aa2options(el) {
		let e = el.map( i => { return { label : i.laa, value: i.laa } });
		e = e.sort( (a,b)=>{ return a.label < b.label ? 1 : -1  });
		this.setState({ aas: e });
	}
	onchange(v) {
		if ( this.props.globPrefix && this.props.name ) {
			window.glob.trigger(
				this.props.globPrefix+'changed',
				{ name: this.props.name, value: typeof v === 'object' ? v.value : undefined }
			);
		}
	}
	render() {
		if ( ! this.state.ente ) {
			this.aas = false;
			return <p className={"comment"}>↳ Scegli prima la Sessione di esame.</p>;
		}
		if ( ! this.state.aas ) {
			setTimeout( ()=>{ this.loadAA() }, 100);
			return <p className={"comment"}><IndefiniteProgressbar /></p>;
		}
		return (
			<div style={{maxWidth:"240px"}}>
				<Select
					id={this.uid}
					options={this.state.aas}
					autoFocus={true}
					onChange={ (v)=> { this.onchange(v) }}
				/>
			</div>
		);
	}
}

export default SelectAA;